import { GoogleGenAI } from "@google/genai";

// Initialize GenAI
// The API key must be obtained exclusively from the environment variable process.env.API_KEY.
const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });

export const calculateSolarPotential = async (
  location: string,
  roofArea: number,
  consumption: number
): Promise<string> => {
  if (!process.env.API_KEY) {
    console.warn("API Key is missing. Please check Environment Variables.");
    return `
      <div class="p-4 bg-yellow-50 text-yellow-800 rounded-lg">
        <strong>Demo-Modus (Kein API-Key gefunden):</strong><br>
        Basierend auf Ihren Eingaben (${roofArea}m² Dachfläche in ${location}) schätzen wir:
        <ul class="mt-2 list-disc pl-5">
          <li>Ertrag: ca. ${roofArea * 200} kWh/Jahr</li>
          <li>Ersparnis: ca. ${Math.round((roofArea * 200 * 0.30))}€ pro Jahr</li>
          <li>Empfehlung: 8-10 kWp Anlage mit Speicher.</li>
        </ul>
      </div>
    `;
  }

  const model = "gemini-2.5-flash";
  const prompt = `
    Act as a senior solar energy consultant for the German market.
    User Data:
    - Location: ${location} (Germany)
    - Roof Area: ${roofArea} sqm
    - Yearly Consumption: ${consumption} kWh

    Task: Provide a concise, motivating summary of their solar potential.
    Include:
    1. Estimated annual production in kWh (assume avg German irradiance).
    2. Estimated annual savings in Euro (assume 0.35€/kWh electricity price).
    3. CO2 savings in tons.
    4. A specific recommendation for a system size (kWp) and battery storage.
    
    Output Format: HTML formatted string (use <strong> for emphasis, <br> for breaks, NO markdown code blocks). Keep it under 150 words. Tone: Professional, encouraging, focused on "saving money" (günstig).
  `;

  try {
    const response = await ai.models.generateContent({
      model,
      contents: prompt,
    });
    return response.text || "Keine Antwort erhalten.";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "Wir konnten Ihre individuelle Berechnung gerade nicht durchführen. Generell sparen Haushalte mit ähnlichen Werten ca. 1.000€ - 1.500€ pro Jahr.";
  }
};